import { Component, Vue } from "vue-property-decorator";
import i18nService from "@/services/i18n";

@Component
export default class AlterationI18nMixin extends Vue {

    private baseLink = 'modules.budget_execution_alteration.';

    public setText(text: string) {
        // const link = `${this.baseLink}${text}`;
        // return this.$t(link) as string;
        const mainTextFieldName = "modules.budget_execution_alteration." + text;
        return this.$t(mainTextFieldName) as string;
    }
    /** Текст ошибки удаления справки, вошедшей в уточненный план
     * @param args: аргументы ошибки modules.budgetExecutionAlteration.error.requestInUtochPlan (номер и дата уточ.плана)
     */
    public requestInUtochPlanText(args: any[]) {
        let number = '';
        let date = '';
        for (const arg of args || []) {
            if (!arg) { continue; }
            if (arg.type === 'number') { number = arg.value; }
            // дата форматируется в локальном времени, toISOString() сдвигает дату в UTC
            if (arg.type === 'date') { date = new Date(arg.value).toLocaleDateString('ru-RU'); }
            if (arg.type === 'string' && !date) { date = arg.value; }
        }
        return this.$t('modules.budget_execution_alteration.errors.requestInUtochPlan', { number, date }) as string;
    }
    public nameLocale(list: any[], code: string = 'code') {
        for (const item of list) {
            this.itemNameLocale(item, code);
        }
    }
    public itemNameLocale(item: any, code: string = 'code') {
        if (item && item !== null) {
            if (item.hasOwnProperty('name_kz')) {
                item['name_kk'] = item['name_kz'];
            }

            if (item.hasOwnProperty('nameKk')) {
                item['name_kk'] = item['nameKk'];
            }

            if (item.hasOwnProperty('nameRu')) {
                item['name_ru'] = item['nameRu'];
            }

            if (!item.hasOwnProperty('name_en')) {
                item['name_en'] = item['name_ru'];
            }

            Object.defineProperty(item, 'name', {
                configurable: true,
                get: function () {
                    if (!item.hasOwnProperty(`name_${i18nService.locale}`) && item.hasOwnProperty('value')
                        && typeof item.value !== 'number' && typeof item.value !== 'string') {
                        return item.value[`name_${i18nService.locale}`];
                    } else {
                        return item[`name_${i18nService.locale}`];
                    }
                }
            });

            if (item.hasOwnProperty(code)) {
                item['code'] = item[code];
                Object.defineProperty(item, 'localText', {
                    configurable: true,
                    get: function () {
                        if (parseInt(item['code']) === 0) { return item['name']; }
                        else { return item[code] + ' - ' + item['name']; }
                    }
                });
                Object.defineProperty(item, 'text', {
                    configurable: true,
                    get: function () {
                        return item['name'];
                    }
                });
            }
        }
    }

    public nameSet(list: any[], code: string = 'code') {
        for (const item of list) {
            this.itemLocaleName(item, code);
        }
    }
    public itemLocaleName(item: any, code: string = 'code') {
        if (item && item !== null) {
            if (!item.hasOwnProperty(`gr_name`)) {
                Object.defineProperty(item, 'gr_name', {
                    configurable: true,
                    get: function () {
                        if (!item.hasOwnProperty(`gr_name_${i18nService.locale}`)) {
                            return item?.value[`gr_name_${i18nService.locale}`];
                        } else {
                            return item[`gr_name_${i18nService.locale}`];
                        }
                    }
                });
            }

            if (!item.hasOwnProperty(`abp_name`)) {
                Object.defineProperty(item, 'abp_name', {
                    configurable: true,
                    get: function () {
                        // Проверяем все возможные точки отказа
                        if (!item || !i18nService?.locale) return undefined;

                        const propertyName = `abp_name_${i18nService.locale}`;

                        // Безопасный доступ ко всем свойствам
                        return item?.[propertyName] ?? item?.value?.[propertyName] ?? undefined;
                    }
                });
            }

            if (!item.hasOwnProperty(`gu_name`)) {
                Object.defineProperty(item, 'gu_name', {
                    configurable: true,
                    get: function () {
                        // Проверяем все возможные точки отказа
                        if (!item || !i18nService?.locale) return undefined;

                        const propertyName = `gu_name_${i18nService.locale}`;

                        // Безопасный доступ ко всем свойствам
                        return item?.[propertyName] ?? item?.value?.[propertyName] ?? undefined;
                    }
                });
            }
            Object.defineProperty(item, 'prg_name', {
                configurable: true,
                get: function () {
                    if (!item.hasOwnProperty(`prg_name_${i18nService.locale}`)) {
                        return item.value[`prg_name_${i18nService.locale}`];
                    } else {
                        return item[`prg_name_${i18nService.locale}`];
                    }
                }
            });
            Object.defineProperty(item, 'ppr_name', {
                configurable: true,
                get: function () {
                    if (!item.hasOwnProperty(`ppr_name_${i18nService.locale}`)) {
                        return item.value[`ppr_name_${i18nService.locale}`];
                    } else {
                        return item[`ppr_name_${i18nService.locale}`];
                    }
                }
            });
            Object.defineProperty(item, 'spf_name', {
                configurable: true,
                get: function () {
                    if (!item.hasOwnProperty(`name_${i18nService.locale}`)) {
                        return item.value[`name_${i18nService.locale}`];
                    } else {
                        return item[`name_${i18nService.locale}`];
                    }
                }
            });
        }
    }


    public incNameSet(list: any[], code: string = 'code') {
        for (const item of list) {
            this.incItemLocaleName(item, code);
        }
    }
    public incItemLocaleName(item: any, code: string = 'code') {
        if (item && item !== null) {
            if (item.hasOwnProperty(code)) {
                item['code'] = item[code];
                Object.defineProperty(item, code + '_name', {
                    configurable: true,
                    get: function () {
                        if (!item.hasOwnProperty(code + `_name_${i18nService.locale}`)) {
                            return item.value[code + `_name_${i18nService.locale}`];
                        } else {
                            return item[code + `_name_${i18nService.locale}`];
                        }
                    }
                });
            }
        }
    }
    public padLeadingZeros(num: any, size: any) {
        let s = String(num);
        while (s.length < size) {
            s = '0' + s;
        }
        return s;
    }
    public async loadSettings(val: any) {
        let result = false;
        const response = await fetch(`/api-py/get-settings`);
        const settingsData = await response.json();
        for (const el of settingsData) {
            if ([val].includes(el['code'].trim())) {
                result = el['value']
            }
        }
        return result;
    }
    protected makeToast(variant: any, title: any, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    } // сообщение
    public async getAccess(moduleCode: string, userId: any) {
        try {
            const result = await fetch(`/api-py/get-access-info/${moduleCode}/${userId}`);
            if (result.status === 200) {
                const res = await result.json();
                if (res.id > 0) {
                    res.editAccess = res['modules'] === '005.002.010'
                        ? res['access_level'] !== 1
                        : res['access_level'] !== 1 && res['operations'] && res['operations'].length > 0;
                    return res;
                }
            } else {
                this.makeToast('danger', 'get-access', `${result.status} - ${result.statusText}`);
            }
        } catch (error) {
            this.makeToast('danger', this.setText('errors.request') +' get-access', error.toString());
        }
    }
    public async getAccessModules(moduleCode: string, userId: any) {
        try {
            const result = await fetch(`/api-py/get-access-modules-info/${moduleCode}/${userId}`);
            if (result.status === 200) {
                return await result.json();
            } else {
                this.makeToast('danger', 'get-access', `${result.status} - ${result.statusText}`);
                return {};
            }
        } catch (error) {
            this.makeToast('danger', this.setText('errors.request') +' get-access-modules', error.toString());
        }
    }
}